import axios from "axios";
import { getAuthItem } from "../utils/authStorage";

const baseURL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:5000/api" : "/api");

const API = axios.create({
  baseURL,
  timeout: 60000,
  withCredentials: true, // HttpOnly userToken cookie for auto-login
});

API.interceptors.request.use((config) => {
  // Bearer from this tab's sessionStorage first (admin "login as user" tab), then localStorage.
  const token = getAuthItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.code === "ECONNABORTED" || err.message?.toLowerCase().includes("timeout")) {
      console.warn("[API] Request timeout:", err.config?.url);
    }
    return Promise.reject(err);
  }
);

export default API;
